import ShipmentHistory from './ShipmentHistory'

export default ShipmentHistory
